import { Component, OnInit, Input } from '@angular/core';
import { Message } from 'primeng//api';
import { GeneralUtils, mobileNoPattern } from '../../general-utils';
import { DataRetrievalService } from '../../data-retrieval.service';

@Component({
  selector: 'app-new-registration-family',
  templateUrl: './new-registration-family.component.html',
  styleUrls: ['./new-registration-family.component.scss']
})
export class NewRegistrationFamilyComponent implements OnInit {

  @Input()
  set projectName(projectName: string) {
    this._projectName = projectName;
    this.clearFormInputs();
    this.getRegistrationDropdownOptions();
  }
  get projectName(): string {
    return this._projectName;
  }

  protected _projectName: string = null;

  disableSubmit = false;

  messages_1: Message[] = [];
  messages_2: Message[] = [];

  mobilePattern = mobileNoPattern;

  dropdownOptions: any = {
    preferredMessageDeliveryTime: [],
    culture: [],
    smokingModule: [],
  };

  enteredFormInput: any = {
    preferredMessageDeliveryTime: null,
    culture: null,
    smokingModule: null,

    programStartDate: null,
    preferredName: null,
    preferredMobileNumber: null,
    confirmMobileNumber: null,
    patientName: null,
    relationshipToPatient: null,
  };

  constructor(protected dataRetrievalService: DataRetrievalService) { }

  ngOnInit() {}

  clearFormInputs() {

    this.enteredFormInput = {
      preferredMessageDeliveryTime: null,
      culture: null,
      smokingModule: null,

      programStartDate: null,
      preferredName: null,
      preferredMobileNumber: null,
      confirmMobileNumber: null,
      patientName: null,
      relationshipToPatient: null,
    };

  }

  getRegistrationDropdownOptions() {

    this.dataRetrievalService.getRegistrationDropdownOptions().subscribe(
      dropdownOptions => {
        this.dropdownOptions = dropdownOptions;
      }
    );

  }

  submitRegistration() {

    this.disableSubmit = true;
    this.messages_1 = [];
    this.messages_2 = [];
    this.messages_2.push({ severity: 'info', summary: 'Sending:', detail: 'Submitting registration, please wait...' });

    const registration = {
      programStartDate: GeneralUtils.convertDateToISODateString(this.enteredFormInput.programStartDate),
      name: this.enteredFormInput.preferredName,
      mobile: this.enteredFormInput.preferredMobileNumber,
      patientName: this.enteredFormInput.patientName,
      patientRelationship: this.enteredFormInput.relationshipToPatient,
      messageDeliveryTime: this.enteredFormInput.preferredMessageDeliveryTime,
      culture: this.enteredFormInput.culture,
      smoking: this.enteredFormInput.smokingModule,
      timezone: 'Pacific/Auckland',
      userType: 'Family',
      projectName: this.projectName,
      projectVersion: '1.0.0'
    };

    this.dataRetrievalService.postUserRegistrationDetails(registration).subscribe(
      response => {

        this.messages_1 = [];
        this.messages_2 = [];

        if (response !== null && response.hasOwnProperty('error')) {
          this.messages_2.push({ severity: 'info', summary: 'Error:', detail: 'Registration not submitted. ' + response.error });
        } else {
          this.messages_1.push({ severity: 'info', summary: 'Sent:', detail: 'Registration submitted. You can now enter a new family registration.' });
          this.clearFormInputs();
          window.scrollTo(0, 0);
        }

        this.disableSubmit = false;

      },

      error => {

        this.messages_1 = [];
        this.messages_2 = [];

        this.messages_2.push({ severity: 'info', summary: 'Error:', detail: 'Registration not submitted. Unknown error.' });

        this.disableSubmit = false;

      }
    );

  }

  numberInputValidator(event: any) {
    GeneralUtils.numberInputValidator(event);
  }

}
